export var RedirectType;
(function (RedirectType) {
    RedirectType["Flow"] = "Flow";
    RedirectType["Agent"] = "Agent";
})(RedirectType || (RedirectType = {}));
